import { IUIConfiguration, IUIConfigurationTranslations } from "../model"

export const getDefaultUIConfiguration = (): IUIConfiguration => ({
  domain: location.host,
  cdnUrl: "",
  page_title: "adstanding",
  font: {
    googleFamily: "Poppins",
    weightLight: 300,
    weightRegular: 400,
    weightMedium: 500,
    weightBold: 700
  },
  colors: {
    error: { light: "#d32f2f", dark: "#d32f2f" },
    primary: { light: "#d6674f", dark: "#d6674f" },
    secondary: { light: "#b2b2b2", dark: "#6e6969" },
    primary2: { light: "#3e7384", dark: "#6badc3" },
    borderDisabled: { light: "#cbcbcb", dark: "#6e6969" },
    backgroundDefault: { light: "#ffffff", dark: "#2f3037" },
    backgroundPaper: { light: "#ededed", dark: "#222327" },
    border: { light: "#e0e0e0", dark: "grey" },
    boxShadow: { light: "rgba(0, 0, 0, 0.12)", dark: "rgba(0, 0, 0, 60%)" },
    form: { light: "#7c797c", dark: "#ffffff" },
    textSpecial: { light: "#ffffff", dark: "#ffffff" },
    textForm: { light: "#ffffff", dark: "#00273B" },
    textDisabled: { light: "#cbcbcb", dark: "#6e6969" },
    textPrimary: { light: "#4b4b4b", dark: "#d5d5d5" },
    textSecondary: { light: "#b2b2b2", dark: "#6e6969" },
    textPrimary2: { light: "#3e7384", dark: "#6badc3" }
  },
  images: {
    logoBig: {
      lightUrl: "/images/logo-light.png",
      darkUrl: "/images/logo-dark.png"
    },
    logoSmall: {
      lightUrl: "/images/logo-trunked.png",
      darkUrl: "/images/logo-trunked.png"
    },
    login: {
      lightUrl: null,
      darkUrl: null
    },
    favicon: {
      lightUrl: "/images/favicon.ico",
      darkUrl: "/images/favicon.ico"
    }
  },
  translations: {
    menuTitle: {
      en: "State of the art planning and buying platform",
      es: "Plataforma de ultima generación, planificación y compra",
      fr: "Plate-forme de planification et d'achat à la pointe",
      ar: "منصة تخطيط وشراء متطورة"
    }
  },
  version: "1.3.4"
})

export const getUiConfigTranslationsForSspUser = (): IUIConfigurationTranslations => ({
  menuTitle: {
    en: "Programmatic Inventory Management Platform",
    es: "Plataforma de gestión programática de inventario",
    fr: "Plateforme de gestion des stocks programmatique",
    ar: "منصة إدارة المخزون البرمجية"
  }
})
